import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import IndustrySave from "./IndustrySave";


const IndustryEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response46 = useInvoke("WebApps", "46", {"@IndustryId": id});
    
    const [industry, setIndustry] = useState({});

    useEffect(() => {

        if (response46.data.payload != undefined) {
            let data = JSON.parse(response46.data.payload).data[0];

            let obj = {
                IndustryId: data[0],
                IndustryName: data[1],
                IndustryCode: data[2],
                CreatedDate: data[3]
            }
            setIndustry(obj);
        }

    }, [response46.isPending]);

    const handleFormSubmit = (e) => {

        let industryid = id;

        let valid = true;

        let industryname = "";
        if (document.getElementById("industryName").value != '') {
            industryname = document.getElementById("industryName").value;
        }
        else {
            industryname = document.getElementById("industryName").defaultValue;
        }
        let industrycode = "";
        if (document.getElementById("NAICSCode").value != '') {
            if (document.getElementById("NAICSCode").value.length < 10) {
                industrycode = document.getElementById("NAICSCode").value;
            }
            else {
                valid = false;
                toast.error("NAICS Code cannot exceed 10 characters");
            }
            
        }
        else {
            industrycode = document.getElementById("NAICSCode").defaultValue;
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            IndustrySave(industryid, industryname, industrycode, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/Industry");
        }

    };

    document.title = "Industry - Edit";
    return ( 
        <div className="industryEdit">
            {user["email"] != undefined && 
                <>

                    {industry && 
                        <div className="container body-content" style={{marginTop: "25px"}}>
                                
                            <h2>Edit Industry</h2>

                            <form id="industryForm" noValidate="novalidate" autoComplete="off">  

                                <div className="form-group">
                                    <label htmlFor="industryName">Industry Name</label>
                                    <input className="form-control" id="industryName" name="industryName" type="text" defaultValue={industry["IndustryName"]} autoComplete="off" />
                                </div>

                                
                                <div className="form-group">
                                    <label htmlFor="NAICSCode">NAICS Code</label>
                                    <input className="form-control" id="NAICSCode" name="NAICSCode" type="text" defaultValue={industry["IndustryCode"]} autoComplete="off" />
                                </div>
                            </form>
                            <Link to="/Industry" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>
                            <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                       
                        </div>
                    }
                </>
            }
        </div>
    );
}
 
export default IndustryEdit;